var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-container" },
    [
      _c("van-nav-bar", {
        attrs: { title: _vm.$route.meta.title },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("van-icon", {
                  attrs: { name: "arrow-left", color: "#46474B", size: "20px" },
                  on: { click: _vm.back }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("div", { staticClass: "pay-success text-align-center" }, [
        _c("img", {
          attrs: { src: require("@/assets/pay-state/pay-success.png"), alt: "" }
        }),
        _c("p", { staticClass: "status" }, [_vm._v(" 支付成功 ")]),
        _vm.$route.query.buyServiceType === "1"
          ? _c("p", { staticClass: "msg font14" }, [
              _vm._v(" 已成功购买"),
              _c("span", [_vm._v(_vm._s(_vm.$route.query.lawyerName))]),
              _vm._v("律师的服务，"),
              _c("span", {
                staticClass: "html-content",
                domProps: { innerHTML: _vm._s(_vm.tipsText) }
              })
            ])
          : _vm.$route.query.buyServiceType === "3"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm.timeIsNight
                ? _c("label", [
                    _vm._v(
                      "当前为非工作时间段（" +
                        _vm._s(_vm._startTime + "-" + _vm._endTime) +
                        "），值班律师"
                    ),
                    _c("br"),
                    _vm._v("较少。您的问题平台已加急派送，如长时间无人接"),
                    _c("br"),
                    _vm._v("单，工作时间律师将会优先为您解答")
                  ])
                : _c("label", [
                    _vm._v("您的问题，我们已通知平台律师，律师会"),
                    _c("br"),
                    _vm._v("在稍后几分钟为您解答")
                  ])
            ])
          : _vm.$route.query.buyServiceType === "4"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm._v(" 律师已收到您的赞赏，谢谢您的认可~ ")
            ])
          : _vm.$route.query.buyServiceType === "6"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm._v(" 感谢您的认可，请继续深入追问 ")
            ])
          : _vm.$route.query.buyServiceType === "7"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm._v(" 您的问题，已进入平台快速咨询通道，律"),
              _c("br"),
              _vm._v("师会在稍后几分钟为您解答。 ")
            ])
          : _vm.$route.query.buyServiceType === "8"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm._v(" 律师已收到您的打赏，感谢您对律师和平台的支持 ")
            ])
          : _vm.$route.query.buyServiceType === "9"
          ? _c("p", { staticClass: "msg msg-sucess font14" }, [
              _vm._v(" 购买成功，您可以点击下载合同模板 ")
            ])
          : _c("p", { staticClass: "msg-none" }),
        _c(
          "div",
          {
            class: [
              "btns flex flex-column",
              _vm.$route.query.buyServiceType === "3" && "zgh-btn"
            ]
          },
          [
            _c("button", { on: { click: _vm.jump } }, [
              _vm._v(" " + _vm._s(_vm.showData.msg) + " ")
            ])
          ]
        ),
        _vm.$route.query.buyServiceType === "3"
          ? _c("div", { staticClass: "gzh-box position-relative" }, [
              _c("img", {
                staticClass: "gzh-banner",
                attrs: {
                  src: require("@/assets/pay-state/Group8293@2x.png"),
                  alt: ""
                }
              }),
              _c("img", {
                staticClass: "gzh-tag position-absolute",
                attrs: {
                  src: require("@/assets/pay-state/btn-tag.png"),
                  alt: ""
                }
              }),
              _c("button", { on: { click: _vm.handleGzh } }, [
                _vm._v("前往公众号")
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }